import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  notifications: [],
  modals: {
    dailyReward: false,
    ticketCollector: false,
  },
  theme: 'dark',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        message: action.payload.message,
        type: action.payload.type || 'info',
        timestamp: new Date().toISOString(),
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    setModal: (state, action) => {
      const { modal, isOpen } = action.payload;
      state.modals[modal] = isOpen;
    },
    setDailyRewardModal: (state, action) => {
      state.modals.dailyReward = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { 
  setLoading, 
  addNotification, 
  removeNotification, 
  clearNotifications,
  setModal,
  setDailyRewardModal,
  setTheme 
} = uiSlice.actions;
export default uiSlice.reducer;
